import React from "react";
import { useTheme } from "../../middleware/ThemeContext";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const NewDomainIcon: React.FC<AddIconProps> = ({ size = 22, color = '#003366', className, onClick }) => {
  const { theme } = useTheme();
  color = theme.name === 'light' ? color : '#ffffff';
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25.6654 14.0007C25.6654 7.55733 20.442 2.33398 13.9987 2.33398C7.55537 2.33398 2.33203 7.55733 2.33203 14.0007C2.33203 20.4439 7.55537 25.6673 13.9987 25.6673" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.168 2.39062C15.168 2.39062 18.668 6.99968 18.668 13.9996" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.832 25.6088C12.832 25.6088 9.33203 20.9996 9.33203 13.9996C9.33203 6.99968 12.832 2.39062 12.832 2.39062" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.06641 18.084H13.9985" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.06641 9.91602H24.9306" stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M25.5257 20.9045C26.1018 21.2589 26.0663 22.1214 25.473 22.1887L22.4786 22.5281L21.1355 25.2258C20.8694 25.7603 20.0468 25.4986 19.9108 24.8361L18.4463 17.7008C18.3313 17.1408 18.8346 16.7883 19.3215 17.0879L25.5257 20.9045Z" stroke={color} strokeWidth="1.75" />
    </svg>

  );
};

export default NewDomainIcon;